module.exports = __webpack_public_path__ + "img/confirm-pairing.d7a18135.svg";